import React from "react"
import { reportIcons } from "../../../../../shared/Data/reportIcons"
import { Remarkable } from 'remarkable'
import {/* instructionFigures,*/ budgetMethodology } from "./instructionFigures"

import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/exportFrontMatter.css'

export function ExportFrontMatter() {
  console.log('rendering front matter', reportIcons)
  return (
    <>
      <div className="cover-pages-binder">
        <div className="sum-title">Budget</div>
        <div className="cover-container">
          <div className="budget">
            <div style={{
              whiteSpace: 'pre-line',
              marginBottom: '5%',
              fontSize: 16
            }}
              dangerouslySetInnerHTML={getRawMarkup(budgetMethodology)}
            />
          </div>
        </div>
      </div>
    </>
  )
}

function getRawMarkup(val) {
  const md = new Remarkable()
  return { __html: md.render(val) }
}



